import { useQuery } from '@tanstack/react-query';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api';

export const useScoringCategories = () => {
  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: adminLocalizationKeys.getAllScoringCategories,
    queryFn: adminLocalizationApi.getAllScoringCategories,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error,
    refetch
  };
};
